import { useState } from "react";
import "@/App.css";
import { motion } from "framer-motion";
import { Phone, Instagram, Music, PartyPopper, GraduationCap, Building2, MessageCircle, Play } from "lucide-react";

// Assets
const LOGO = "https://customer-assets.emergentagent.com/job_c6254c7e-fe12-4b70-8f1d-a433ca7603d0/artifacts/626s7uug_WhatsApp%20Image%202026-03-19%20at%2011.12.39.jpeg";
const HERO_BG = "https://customer-assets.emergentagent.com/job_c6254c7e-fe12-4b70-8f1d-a433ca7603d0/artifacts/0bdc3e7f_WhatsApp%20Image%202026-03-19%20at%2011.10.21.jpeg";
const GALLERY_IMAGES = [
  {
    url: "https://customer-assets.emergentagent.com/job_c6254c7e-fe12-4b70-8f1d-a433ca7603d0/artifacts/0bdc3e7f_WhatsApp%20Image%202026-03-19%20at%2011.10.21.jpeg",
    alt: "Grupo Atitude Samba Show",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_c6254c7e-fe12-4b70-8f1d-a433ca7603d0/artifacts/03rqbx7p_WhatsApp%20Image%202026-03-19%20at%2011.12.22.jpeg",
    alt: "Atitude Samba Show em evento corporativo",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_atitude-samba/artifacts/1c1n9ms4_WhatsApp%20Image%202026-03-19%20at%2017.02.59.jpeg",
    alt: "Atitude Samba Show em casamento",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_atitude-samba/artifacts/bmqliy6w_WhatsApp%20Image%202026-03-19%20at%2017.13.03%20%281%29.jpeg",
    alt: "Grupo com passistas",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_c6254c7e-fe12-4b70-8f1d-a433ca7603d0/artifacts/543au8h9_WhatsApp%20Image%202026-03-19%20at%2011.11.29.jpeg",
    alt: "Show de samba em festa",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_c6254c7e-fe12-4b70-8f1d-a433ca7603d0/artifacts/5wrwk12x_WhatsApp%20Image%202026-03-19%20at%2011.11.06.jpeg",
    alt: "Passistas e músicos",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_atitude-samba/artifacts/n4oue2js_WhatsApp%20Image%202026-03-19%20at%2017.09.04.jpeg",
    alt: "Equipe na piscina",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_atitude-samba/artifacts/dki0o8jg_WhatsApp%20Image%202026-03-19%20at%2017.13.03.jpeg",
    alt: "Grupo em evento",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_atitude-samba/artifacts/fww4ndz1_WhatsApp%20Image%202026-03-19%20at%2017.13.03%20%282%29.jpeg",
    alt: "Show no Viva AABB",
  },
];

const VIDEOS = [
  {
    url: "https://customer-assets.emergentagent.com/job_atitude-samba/artifacts/rpkf2xje_WhatsApp%20Video%202026-03-19%20at%2016.12.34.mp4",
    poster: "https://customer-assets.emergentagent.com/job_c6254c7e-fe12-4b70-8f1d-a433ca7603d0/artifacts/0bdc3e7f_WhatsApp%20Image%202026-03-19%20at%2011.10.21.jpeg",
    alt: "Atitude Samba Show ao vivo",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_atitude-samba/artifacts/aagy4ewg_WhatsApp%20Video%202026-03-19%20at%2016.12.38.mp4",
    poster: "https://customer-assets.emergentagent.com/job_atitude-samba/artifacts/bmqliy6w_WhatsApp%20Image%202026-03-19%20at%2017.13.03%20%281%29.jpeg",
    alt: "Show de samba",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_atitude-samba/artifacts/cjw17lxf_WhatsApp%20Video%202026-03-19%20at%2016.12.40.mp4",
    poster: "https://customer-assets.emergentagent.com/job_atitude-samba/artifacts/fww4ndz1_WhatsApp%20Image%202026-03-19%20at%2017.13.03%20%282%29.jpeg",
    alt: "Apresentação ao vivo",
  },
];

// Contact info
const CONTACTS = {
  joao: { name: "João", phone: "11 95875-8425", whatsapp: "5511958758425" },
  rafael: { name: "Rafael", phone: "11 94141-1410", whatsapp: "5511941411410" },
  instagram: "@atitudesambashow",
};

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 }
};

const staggerContainer = {
  initial: {},
  whileInView: { transition: { staggerChildren: 0.1 } },
  viewport: { once: true }
};

// Components
const FloatingWhatsApp = () => (
  <motion.a
    href={`https://wa.me/${CONTACTS.joao.whatsapp}?text=Olá! Gostaria de saber mais sobre o Atitude Samba Show`}
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 bg-green-500 text-white p-3 md:p-4 rounded-full shadow-lg hover:bg-green-600 transition-colors whatsapp-float"
    data-testid="floating-whatsapp-btn"
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
  >
    <MessageCircle className="w-6 h-6 md:w-7 md:h-7" />
  </motion.a>
);

const Navigation = () => (
  <motion.nav
    initial={{ y: -100, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.5 }}
    className="hidden sm:flex fixed top-3 left-1/2 -translate-x-1/2 bg-white/95 backdrop-blur-md px-4 py-2.5 md:px-6 md:py-3 rounded-full shadow-lg z-50 items-center gap-3 md:gap-6 border border-gray-100"
    data-testid="navigation"
  >
    <img src={LOGO} alt="Atitude Samba Show" className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover flex-shrink-0" />
    <div className="flex items-center gap-3 md:gap-6">
      <a href="#servicos" className="text-[#1A1A1A] hover:text-[#4A90D9] transition-colors font-medium tracking-wide text-xs md:text-sm">SERVIÇOS</a>
      <a href="#galeria" className="text-[#1A1A1A] hover:text-[#4A90D9] transition-colors font-medium tracking-wide text-xs md:text-sm">GALERIA</a>
      <a href="#contato" className="text-[#1A1A1A] hover:text-[#4A90D9] transition-colors font-medium tracking-wide text-xs md:text-sm">CONTATO</a>
    </div>
  </motion.nav>
);

const HeroSection = () => (
  <section 
    className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16 pb-8"
    data-testid="hero-section"
  >
    <div 
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url(${HERO_BG})` }}
    />
    <div className="absolute inset-0 hero-overlay" />
    
    <div className="relative z-10 text-center px-5 w-full max-w-4xl mx-auto">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <img 
          src={LOGO} 
          alt="Atitude Samba Show Logo" 
          className="w-28 h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 mx-auto rounded-full border-3 md:border-4 border-white shadow-2xl object-cover mb-6 md:mb-8"
          data-testid="hero-logo"
        />
      </motion.div>
      
      <motion.h1
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-normal text-white mb-4 md:mb-6 text-shadow tracking-wider"
        style={{ fontFamily: 'Bebas Neue, sans-serif' }}
        data-testid="hero-title"
      >
        ATITUDE SAMBA SHOW
      </motion.h1>
      
      <motion.p
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="text-sm sm:text-base md:text-lg text-white/90 mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed font-light px-2"
        data-testid="hero-tagline"
      >
        "Faça do seu evento um verdadeiro carnaval, há 10 anos proporcionando momentos inesquecíveis."
      </motion.p>
      
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        className="flex flex-col gap-3 sm:flex-row sm:gap-4 justify-center px-4"
      >
        <a
          href={`https://wa.me/${CONTACTS.joao.whatsapp}?text=Olá! Gostaria de solicitar um orçamento para meu evento`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 bg-[#4A90D9] text-white px-6 py-3.5 md:px-8 md:py-4 rounded-full font-medium text-sm md:text-base hover:bg-[#3A7BC8] transition-all active:scale-95 shadow-lg tracking-wide"
          data-testid="hero-cta-btn"
        >
          <Phone className="w-4 h-4 md:w-5 md:h-5" />
          SOLICITAR ORÇAMENTO
        </a>
        <a
          href="#galeria"
          className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-6 py-3.5 md:px-8 md:py-4 rounded-full font-medium text-sm md:text-base hover:bg-white/10 transition-all active:scale-95 tracking-wide"
          data-testid="hero-gallery-btn"
        >
          VER GALERIA
        </a>
      </motion.div>
    </div>
    
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1 }}
      className="absolute bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 hidden sm:block"
    >
      <motion.div
        animate={{ y: [0, 8, 0] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
        className="w-5 h-8 md:w-6 md:h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-1.5 md:p-2"
      >
        <motion.div className="w-1 h-2 md:w-1.5 md:h-2.5 bg-white/70 rounded-full" />
      </motion.div>
    </motion.div>
  </section>
);

const services = [
  { icon: GraduationCap, title: "FORMATURAS", description: "Celebre sua conquista com muita alegria e samba!" },
  { icon: PartyPopper, title: "ANIVERSÁRIOS", description: "Transforme sua festa em um evento inesquecível" },
  { icon: Building2, title: "CORPORATIVOS", description: "Anime sua empresa com o melhor do samba" },
  { icon: Music, title: "CASAMENTOS", description: "O ritmo perfeito para o dia mais especial" },
];

const ServicesSection = () => (
  <section id="servicos" className="py-16 md:py-24 lg:py-32 bg-white" data-testid="services-section">
    <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8">
      <motion.div {...fadeInUp} className="text-center mb-10 md:mb-16">
        <h2 
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-[#1A1A1A] mb-3 md:mb-4 tracking-wider"
          style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          data-testid="services-title"
        >
          NOSSOS SERVIÇOS
        </h2>
        <p className="text-gray-600 text-sm md:text-base lg:text-lg max-w-xl mx-auto px-4">
          Levamos a energia do carnaval para todos os tipos de eventos
        </p>
      </motion.div>
      
      <motion.div 
        {...staggerContainer}
        className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6"
      >
        {services.map((service, index) => (
          <motion.div
            key={service.title}
            variants={{
              initial: { opacity: 0, y: 20 },
              whileInView: { opacity: 1, y: 0 }
            }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            className="service-card bg-[#F5F5F0] rounded-xl md:rounded-2xl p-4 sm:p-5 md:p-8 text-center"
            data-testid={`service-card-${index}`}
          >
            <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-[#4A90D9] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-6">
              <service.icon className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-white" />
            </div>
            <h3 
              className="text-base sm:text-lg md:text-2xl text-[#1A1A1A] mb-1.5 md:mb-3 tracking-wide"
              style={{ fontFamily: 'Bebas Neue, sans-serif' }}
            >
              {service.title}
            </h3>
            <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">{service.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

const GallerySection = () => (
  <section id="galeria" className="py-16 md:py-24 lg:py-32 bg-[#1A1A1A]" data-testid="gallery-section">
    <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8">
      <motion.div {...fadeInUp} className="text-center mb-10 md:mb-16">
        <h2 
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white mb-3 md:mb-4 tracking-wider"
          style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          data-testid="gallery-title"
        >
          GALERIA
        </h2>
        <p className="text-gray-400 text-sm md:text-base lg:text-lg max-w-xl mx-auto">
          Momentos especiais que já proporcionamos
        </p>
      </motion.div>
      
      <motion.div 
        {...staggerContainer}
        className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4"
      >
        {GALLERY_IMAGES.map((image, index) => (
          <motion.div
            key={index}
            variants={{
              initial: { opacity: 0, scale: 0.95 },
              whileInView: { opacity: 1, scale: 1 }
            }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            className={`image-zoom rounded-xl md:rounded-2xl overflow-hidden shadow-xl ${
              index === 0 ? 'col-span-2 sm:col-span-2 aspect-video' : 'aspect-square'
            }`}
            data-testid={`gallery-image-${index}`}
          >
            <img
              src={image.url}
              alt={image.alt}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

const VideoCard = ({ video, index }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <motion.div
      variants={{
        initial: { opacity: 0, y: 20 },
        whileInView: { opacity: 1, y: 0 }
      }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      className="relative rounded-xl md:rounded-2xl overflow-hidden shadow-xl bg-[#1A1A1A] aspect-[9/16]"
      data-testid={`video-${index}`}
    >
      {!isPlaying ? (
        <div 
          className="relative w-full h-full cursor-pointer group"
          onClick={() => setIsPlaying(true)}
        >
          <img
            src={video.poster}
            alt={video.alt}
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-white/90 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
              <Play className="w-7 h-7 md:w-9 md:h-9 text-[#1A1A1A] ml-1" fill="#1A1A1A" />
            </div>
          </div>
        </div>
      ) : (
        <video
          src={video.url}
          className="w-full h-full object-cover"
          controls
          autoPlay
          playsInline
        />
      )}
    </motion.div>
  );
};

const VideosSection = () => (
  <section id="videos" className="py-16 md:py-24 lg:py-32 bg-white" data-testid="videos-section">
    <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8">
      <motion.div {...fadeInUp} className="text-center mb-10 md:mb-16">
        <h2 
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-[#1A1A1A] mb-3 md:mb-4 tracking-wider"
          style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          data-testid="videos-title"
        >
          VÍDEOS
        </h2>
        <p className="text-gray-600 text-sm md:text-base lg:text-lg max-w-xl mx-auto">
          Confira a energia dos nossos shows ao vivo
        </p>
      </motion.div>
      
      <motion.div 
        {...staggerContainer}
        className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6"
      >
        {VIDEOS.map((video, index) => (
          <VideoCard key={index} video={video} index={index} />
        ))}
      </motion.div>
    </div>
  </section>
);

const ContactSection = () => (
  <section id="contato" className="py-16 md:py-24 lg:py-32 bg-white" data-testid="contact-section">
    <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8">
      <motion.div {...fadeInUp} className="text-center mb-10 md:mb-16">
        <h2 
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-[#1A1A1A] mb-3 md:mb-4 tracking-wider"
          style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          data-testid="contact-title"
        >
          FALE CONOSCO
        </h2>
        <p className="text-gray-600 text-sm md:text-base lg:text-lg max-w-xl mx-auto">
          Entre em contato e solicite seu orçamento
        </p>
      </motion.div>
      
      <motion.div 
        {...staggerContainer}
        className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-12"
      >
        <motion.a
          href={`https://wa.me/${CONTACTS.joao.whatsapp}?text=Olá João! Gostaria de saber mais sobre o Atitude Samba Show`}
          target="_blank"
          rel="noopener noreferrer"
          variants={{
            initial: { opacity: 0, x: -20 },
            whileInView: { opacity: 1, x: 0 }
          }}
          transition={{ duration: 0.4 }}
          className="contact-card bg-[#F5F5F0] rounded-xl md:rounded-2xl p-4 md:p-6 flex items-center gap-4 md:gap-5 active:scale-[0.98]"
          data-testid="contact-joao"
        >
          <div className="w-12 h-12 md:w-14 md:h-14 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
            <Phone className="w-5 h-5 md:w-6 md:h-6 text-white" />
          </div>
          <div>
            <h3 
              className="text-xl md:text-2xl text-[#1A1A1A] tracking-wide"
              style={{ fontFamily: 'Bebas Neue, sans-serif' }}
            >
              {CONTACTS.joao.name}
            </h3>
            <p className="text-gray-600 text-sm md:text-base">{CONTACTS.joao.phone}</p>
            <span className="text-green-600 text-xs md:text-sm font-medium">Clique para WhatsApp</span>
          </div>
        </motion.a>

        <motion.a
          href={`https://wa.me/${CONTACTS.rafael.whatsapp}?text=Olá Rafael! Gostaria de saber mais sobre o Atitude Samba Show`}
          target="_blank"
          rel="noopener noreferrer"
          variants={{
            initial: { opacity: 0, x: 20 },
            whileInView: { opacity: 1, x: 0 }
          }}
          transition={{ duration: 0.4 }}
          className="contact-card bg-[#F5F5F0] rounded-xl md:rounded-2xl p-4 md:p-6 flex items-center gap-4 md:gap-5 active:scale-[0.98]"
          data-testid="contact-rafael"
        >
          <div className="w-12 h-12 md:w-14 md:h-14 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
            <Phone className="w-5 h-5 md:w-6 md:h-6 text-white" />
          </div>
          <div>
            <h3 
              className="text-xl md:text-2xl text-[#1A1A1A] tracking-wide"
              style={{ fontFamily: 'Bebas Neue, sans-serif' }}
            >
              {CONTACTS.rafael.name}
            </h3>
            <p className="text-gray-600 text-sm md:text-base">{CONTACTS.rafael.phone}</p>
            <span className="text-green-600 text-xs md:text-sm font-medium">Clique para WhatsApp</span>
          </div>
        </motion.a>
      </motion.div>

      <motion.div {...fadeInUp} className="text-center">
        <a
          href="https://instagram.com/atitudesambashow"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 md:gap-3 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 text-white px-6 py-3 md:px-8 md:py-4 rounded-full font-medium text-sm md:text-base hover:scale-105 active:scale-95 transition-transform shadow-lg tracking-wide"
          data-testid="contact-instagram"
        >
          <Instagram className="w-4 h-4 md:w-5 md:h-5" />
          {CONTACTS.instagram}
        </a>
      </motion.div>
    </div>
  </section>
);

const Footer = () => (
  <footer className="bg-[#1A1A1A] text-white py-8 md:py-12" data-testid="footer">
    <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 md:gap-6">
        <div className="flex items-center gap-3 md:gap-4">
          <img src={LOGO} alt="Atitude Samba Show" className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover" />
          <div>
            <h3 
              className="text-base md:text-xl tracking-wider"
              style={{ fontFamily: 'Bebas Neue, sans-serif' }}
            >
              ATITUDE SAMBA SHOW
            </h3>
            <p className="text-gray-500 text-xs md:text-sm">10 anos de tradição em samba</p>
          </div>
        </div>
        
        <div className="flex items-center gap-5 md:gap-6">
          <a
            href="https://instagram.com/atitudesambashow"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-[#4A90D9] transition-colors"
            data-testid="footer-instagram"
          >
            <Instagram className="w-5 h-5 md:w-6 md:h-6" />
          </a>
          <a
            href={`https://wa.me/${CONTACTS.joao.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-green-400 transition-colors"
            data-testid="footer-whatsapp"
          >
            <MessageCircle className="w-5 h-5 md:w-6 md:h-6" />
          </a>
        </div>
      </div>
      
      <div className="border-t border-gray-800 mt-6 md:mt-8 pt-6 md:pt-8 text-center">
        <p className="text-gray-600 text-xs md:text-sm">
          © {new Date().getFullYear()} Atitude Samba Show. Todos os direitos reservados.
        </p>
      </div>
    </div>
  </footer>
);

function App() {
  return (
    <div className="App" data-testid="app-container">
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <GallerySection />
      <VideosSection />
      <ContactSection />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
